<template>
  <a v-if="isLinkAllowed" :href="link" :title="name">{{ name }}</a>
  <span v-else :title="strings.notAllowed">{{ name }}</span>
</template>

<script>
import { getOpenURLByType, opensWithNewWorkspace } from '@/utils'

export default {
  data () {
    return {
      strings: {
        notAllowed: this.translate('not allowed to open item')
      },
      data: {}
    }
  },
  props: {
    canCreateWorkspaces: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isLinkAllowed () {
      // Make Flags
      const restricted = opensWithNewWorkspace(this.data.Type)
      const capable = this.canCreateWorkspaces
      const isAllowed = (capable || !restricted)
      // Disable Certain Links for Viewer Users
      return isAllowed
    },
    name () {
      return this.data.Name
    },
    link () {
      return getOpenURLByType(this.data.Type, this.data.Id)
    }
  },
  methods: {
    translate (string, object) {
      return this.$i18n.translate(string, object)
    }
  }
}
</script>

<style>
</style>
